import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const WaterSystemSearchModalProvider = ({ children }) => {
  const [showSystemSelectModal, setShowSystemSelectModal] = useState(false);

  return (
    <ModalContext.Provider value={{ showSystemSelectModal, setShowSystemSelectModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useWaterSystemSearchModal = () => useContext(ModalContext);
